angular.module('gym.components').directive('memberStyle', function() {
  return {
    restrict: 'E',
    template: require('templates/components/contacts/member_style.html.slim')
  };
});
